import { Observable, of, switchMap, throwError } from "rxjs";
import { RESTApplicationResponse } from "@adgate/common/types/rest-application-response.type";
import { NetworkService } from "./network-service";
import { inject } from "@angular/core";

export class BaseService
{
    private networkService:NetworkService = inject(NetworkService);

    protected getNetworkService(): NetworkService
    {
        return this.networkService;
    }

    protected sendRequest( url: string, payload: any | null, method: 'get' | 'post' | 'put' | 'delete', withCredentials: boolean = false ): Observable<any>
    {
        return this.networkService.sendRequest(url, payload,method, withCredentials).pipe(
            switchMap((r:RESTApplicationResponse) => {
                return this.testError(r);
            })
        );
    }

    protected testError(r: RESTApplicationResponse): Observable<any>
    {
        return r.success ? of(r) : throwError(() => new Error(r.message));
    }
}